/*
* 课程分类
*/

<template>
  <div class="hbn-container" id="userInfo">
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="分类名称">
                  <el-input
                    id="name"
                    v-model="PageQuery.queryModel.name"
                    placeholder="分类名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button size="mini" class="hbn-button-serach" @click="GetData"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          style="width:8rem"
          class="custom-button"
          type="primary"
          @click="handleClick(null,'AddParent')"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增根节点</span>
        </el-button>

            <vxe-button @click="$refs.xTree1.setAllTreeExpand(true)">展开所有</vxe-button>
            <vxe-button @click="$refs.xTree1.clearTreeExpand()">关闭所有</vxe-button>

        <el-button v-show="false" type="primary" class="custom-button" @click="importExcel">
          <i class="el-icon-upload custom-icon"></i>
          <span>导入</span>
        </el-button>
        <el-button v-show="false" type="primary" class="custom-button" @click="export2Excel">
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
      </div>

      <div class="custom-table-layer">
        <vxe-table
          border
          show-overflow
          ref="xTree1"
          :row-config="{keyField: 'id'}"
          :data="DataList"
          :tree-config="{transform: true, expandAll: true}">

          <!-- <vxe-column type="seq" width="180" title="序号" tree-node></vxe-column> -->

          <template v-for="(item,index) in CourseCategoryList" :key="index">
            <vxe-column
              v-if="item.isShow && item.prop=='name'"
              :field="item.prop"
              :title="item.label"
              :width="item.width"
              align="center"
              show-overflow-tooltip
              :class-name="JSON.stringify(item)"
              :formatter="formatterData"
              tree-node
             ></vxe-column>

            <vxe-column
              v-if="item.isShow && item.prop!='name'"
              :field="item.prop"
              :title="item.label"
              :width="item.width"
              align="center"
              show-overflow-tooltip
              :class-name="JSON.stringify(item)"
              :formatter="formatterData"
             ></vxe-column>
          </template>

          <vxe-column title="操作" width="200">
            <template #default="{ row }">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(row, 'Modify')"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(row, 'Delete')"
                  >删除</el-button
                >
                <el-button
                  v-if="row.parentId==0"
                  type="text"
                  size="small"
                  @click="handleClick(row, 'Add')"
                  >新增子节点</el-button
                >
            </template>
          </vxe-column>

        </vxe-table>

      </div>
    </div>
    <CourseCategoryEdit
      ref="CourseCategoryEdit"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-cancel="handleCancel"
      @handle-confirm="handleConfirm"
    ></CourseCategoryEdit>
    <excel
      ref="industrialUnitExcel"
      :importurl="importurl"
      fileName="课程分类.xlsx"
      :dialogVisible="UpLoaddialogVisible"
      @close-dialog="closeUpDialog"
      @error="error"
      @success="success"
    ></excel>
  </div>
</template>

<script>
import { Search, Delete } from "@element-plus/icons";
import { CourseCategoryList } from "@/assets/apiData/Course/CourseCategoryList";
import { GetDataCourseCategoryList, DeleteCourseCategory } from "@api/ApiCourseCategory";
import CourseCategoryEdit from "@comp/Course/CourseCategoryEdit.vue";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
import { VxeTableInstance } from 'vxe-table'
// import XEUtils from "xe-utils";
import { ElMessageBox } from "element-plus";
import { dateFormat } from "@/util/utils.js";
export default {
  data() {
    return {
      PageQuery: {
        queryModel: {},
        pageindex: 1,
        PageSize: 1000,
      },
      multipleSelection: [],
      dialogVisible: false,
      UpLoaddialogVisible: false,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,
      Unit: {
        CodeID: "",
        Name: "",
      },
      UnitList: [],
      DataList: [],
      url: "",
      importurl: "/api/IndustrialUnit/ImportExcel?tabname=IndustrialUnit",
      CourseCategoryList:[]
    };
  },
  components: {
    CourseCategoryEdit,
    excel,
    Search,
  },
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
          break;
        case "isLeaf":
          cellValue = cellValue ? "是" : "否";
          break;
      }
      return cellValue;
    },
    error() {},
    success() {},
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
    },
    importExcel() {
      this.UpLoaddialogVisible = true;
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径
        // debugger;

        const tHeader = [
          ...Enumerable.from(v.UnitList)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(v.UnitList)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名
        const list = v.DataList;
        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `课程分类`);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleClick(row, type) {
      var _this = this;
      if (type == "Delete") {
        ElMessageBox.confirm(`是否要删除?`, "提示", {
          cancelButtonClass: "cancelstyle",
          confirmButtonClass: "confirmstyle",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
        })
          .then(() => {
            DeleteCourseCategory(row.id).then(function (data) {
              if (data) {
                _this.$message.success("删除成功");
               _this.GetData()
              }
            });
          })
          .catch(() => {
            return;
          });
      }
      else if(type == "AddParent")
      {
        _this.dialogVisible = true;
        _this.$refs.CourseCategoryEdit.loadDataById({}, type);
      }else{
        _this.dialogVisible = true;
        _this.$refs.CourseCategoryEdit.loadDataById(row, type);
      }
    },
    GetData() {
        const _this = this;
        this.SearchDataInfo();

        GetDataCourseCategoryList(_this.PageQuery).then(function (data) {
            _this.DataList = data.entities
            _this.$nextTick(() => _this.$refs.xTree1.setAllTreeExpand(true));
        });
    },
    SearchDataInfo() {
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.GetData();
    },
  },
  created() {
    this.CourseCategoryList = CourseCategoryList
    this.GetData();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
</style>
